import SignUpForm from "./SignUpForm";

export default function SignUp() {
  return (
    <div className="fixed inset-0 bg-[#0A1628] overflow-y-auto" style={{ WebkitOverflowScrolling: 'touch' }}>
      <div className="min-h-full flex items-center justify-center p-4">
      <div className="w-full max-w-lg">
        <div className="text-center mb-8">
          <img
            src="https://cdn.prod.website-files.com/6656cc98d077ac69272f468d/666c3d6f5a0ea57d121a1846_Logo.webp"
            alt="FixFinder Logo"
            className="h-12 mx-auto mb-6"
          />
          <h1 className="text-3xl font-bold text-white mb-2">Research Portal Application</h1>
          <p className="text-gray-400">
            Join our research program to help shape the future of IT solutions
          </p>
        </div>

        <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-8 shadow-2xl border border-white/10">
          <SignUpForm />
        </div>

        <p className="text-center text-gray-500 text-sm mt-6">
          Already have access?{" "}
          <a href="/" className="text-[#0193F8] hover:text-[#0173C8] transition-colors">
            Sign in here
          </a>
        </p>
      </div>
      </div>
    </div>
  );
}
